module.exports = __webpack_public_path__ + "img/1080_07.14bdd141.jpg";